export const brand = {
  name: 'EZ FLOW',
  logoUrl: '/logo.svg',
  colors: {
    primary: '#14b8a6',
    secondary: '#64748b',
    accent: '#2dd4bf',
  },
} as const;
